import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../common/button/SubmitButtton";
import useShowAlert from "../../../utiles/AlertUtiles";
import { removeWhitespace } from "../../../utiles/helpers";

const ForgotPassword = () => {

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const showAlert = useShowAlert();
  const navigate = useNavigate();
  const savedEmail = localStorage.getItem("userEmail");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const Logo = process.env.REACT_APP_LOGO_URL;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Email is required.");
      return;
    }

    if (!emailRegex.test(email)) {
      setError("Please enter valid email address");
      return;
    }
    if (email !== savedEmail) {
      setError("Email does not match the registered email.");
      return;
    }
    setLoading(true);

    setTimeout(() => {
      showAlert("success", "Otp sent to your email.");
      localStorage.setItem("ForgetEmail",email);
      setLoading(false);
      navigate("/verify-otp");
         }, 1000);
  };

  
  
  return (
    <div>
      <div className="wrapper">
        <div className="section-authentication-cover">
          <div className="">
            <div className="row g-0">
              <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                  <div className="card-body">
                    <img
                      src="/assets/images/v1/login-image/bankImg.png"
                      className="img-fluid"
                      width="600"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                  <div className="card-body p-sm-5">
                    <div className="p-3 text-center">
                      <div className="text-center">
                        <img src={Logo} width="60" alt="" />
                      </div>
                      <h4 className="text-center mt-5 font-weight-bold">
                        Forgot Password? 🔒
                      </h4>
                      <p className="text-center text-muted">
                      Enter your  email  and we’ll send you a OTP to reset your password
                      </p>
                      <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-12">
                          <label
                            htmlFor="EmailAddress"
                            className="form-label  text-left"
                          >
                            Email<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="EmailAddress"
                            autoComplete="off"
                            value={email}
                            onChange={(e) => {
                              setError("");
                              setEmail(removeWhitespace(e.target.value.trim().toLowerCase()));
                            }}
                          />
                          {error && (
                            <small className="text-danger pt-2  text-left">
                              {error}
                            </small>
                          )}
                        </div>

                        <SubmitButton
                          label="Send OTP"
                          loading={loading}
                        />
                        <div className="d-grid mt-3">
                          <a href="/login" className="btn btn-light">
                            Back To Login
                          </a>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
